export default {
  print(URL) {
    const popup = window.open(URL);
    popup.focus(); /* required for IE */
    popup.print();
  },
  getLightbox(targetURL, thumbURL) {
    const imgSRC = thumbURL || targetURL;
    const $content = $('<div></div>');
    const img = $('<img style="width: 100%;"/>').attr('src', imgSRC);
    /** aggiunge un pulsante per stampare **/
    const printButton = $('<div style="text-align:right;"><a href="#print"><i class="fa fa-2x fa-print"/></a></div>').on('click', () => {
      this.print(targetURL);
    });
    $content.append(img);
    $content.append(printButton);
    return $content;
  },
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // enable lightbox on links with the lightbox class
    const configuration = {
      namespace: 'featherlight',
      targetAttr: 'data-featherlight',
      variant: null,
      resetCss: false,
      background: null,
      openTrigger: 'click',
      closeTrigger: 'click',
      filter: null,
      root: 'body',
      openSpeed: 250,
      closeSpeed: 250,
      closeOnClick: 'background',
      closeOnEsc: true,
      closeIcon: '&#10005;',
      loading: '',
      persist: false,
      otherClose: null,
      beforeOpen: $.noop,
      beforeContent: $.noop,
      beforeClose: $.noop,
      afterOpen: $.noop,
      afterContent: $.noop,
      afterClose: $.noop,
      onKeyUp: $.noop,
      onResize: $.noop,
      type: null,
      contentFilters: ['jquery', 'image', 'html', 'ajax', 'text'],
      // jquery/image/html/ajax/text: undefined
    };
    // jQuery('a.lightbox').featherlight('image', {});
    jQuery('a.lightbox').on('click', (e) => {
      e.preventDefault();
      const $el = $(e.currentTarget);
      const targetURL = $el.attr('href');
      const lightbox = this.getLightbox(targetURL);
      $.featherlight(lightbox, configuration);
    });

    jQuery('div.lightbox img').on('click', (e) => {
      e.preventDefault();
      const $el = $(e.currentTarget);
      const targetURL = $el.attr('src');
      const lightbox = this.getLightbox(targetURL);
      $.featherlight(lightbox, configuration);
    }).css({
      cursor: 'pointer',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/Common.js